import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TEMPLATE_CATEGORIES_URL } from './helpers';
import {
  IDocumentAssemblerTemplateCategoryListResponse,
  TDocumentAssemblerListTemplateCategoriesParams,
} from './types';

export const useDocumentAssemblerTemplateCategories = (
  options?: TDocumentAssemblerListTemplateCategoriesParams & {
    enabled?: boolean;
  }
) => {
  const query = new URLSearchParams();
  if (options?.key) query.append('key', options.key);
  // Appended only when true: the server's transform accepts the literal 'true'/'false' and 400s on
  // anything else, and omitting it keeps the SWR key stable with the server default.
  if (options?.includeArchived) query.append('includeArchived', 'true');

  const search = query.toString();
  const isEnabled = options?.enabled ?? true;

  const { data, error, isLoading, mutate } =
    useSWR<IDocumentAssemblerTemplateCategoryListResponse>(
      isEnabled
        ? `${TEMPLATE_CATEGORIES_URL}${search ? `?${search}` : ''}`
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    templateCategories: data?.templateCategories,
    count: data?.count,
    error,
    isLoading,
    mutate,
  };
};
